import React, { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/contactherosection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroImage from "../assets/images/Hero Image/HeroImage.jpg"

function ContactHeroSection() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="contact-hero-section d-flex align-items-center text-white position-relative" id="home">
      {/* Background Image with Overlay */}
      <div className="hero-bg">
        <img
          src={HeroImage}
          alt="Hero Background"
          className="hero-img"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container position-relative text-center text-md-start">
        <div className="row">
          <div className="col-lg-7" data-aos="fade-right">
            <div className="hero-badge" data-aos="fade-down" data-aos-delay="100">
              <span><i className="bi bi-headset me-2"></i>24/7 Support Available</span>
            </div>
            <h1 className="hero-title fw-bold text-shadow mb-3">
              Get in Touch <span className="highlight">With Us</span>
            </h1>
            <div className="divider mb-4" data-aos="fade-right" data-aos-delay="200"></div>
            <p className="hero-subtitle fs-5 mb-4" data-aos="fade-up" data-aos-delay="300">
              Have questions about our VRF systems? Our team
              <span className="d-md-block"> is here to help with expert guidance, quotes, and support.</span>
            </p>

            {/* Buttons */}
            <div className="d-flex flex-wrap gap-3 justify-content-md-start justify-content-center mt-4" data-aos="fade-up" data-aos-delay="400">
              <a href="tel:+917358052100" className="btn btn-lg contact-btn">
                <i className="bi bi-telephone-fill me-2"></i> Call Us
              </a>
              <a href="#formsubmission" className="btn btn-lg contact-btn-outline">
                <i className="bi bi-envelope-fill me-2"></i> Send Message
              </a>
            </div>

            <div className="hero-features mt-5" data-aos="fade-up" data-aos-delay="500">
              <div className="d-flex flex-wrap">
                <div className="feature-items">
                  <i className="bi bi-patch-check-fill"></i>
                  <span>Expert Support</span>
                </div>
                <div className="feature-items">
                  <i className="bi bi-clock-fill"></i>
                  <span>Quick Response</span>
                </div>
                <div className="feature-items">
                  <i className="bi bi-shield-fill-check"></i>
                  <span>Trusted Service</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5" data-aos="fade-left" data-aos-delay="300">
            <div className="contact-card">
              <div className="card-head">
                <h3><i className="bi bi-lightning-charge-fill me-2"></i> Quick Contact</h3>
              </div>
              <div className="card-body">
                <div className="contact-info-item">
                  <i className="bi bi-geo-alt-fill"></i>
                  <div>
                    <h5 className='text-start'>Our Location</h5>
                    <p>Chennai 600125, Tamil Nadu, India</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <i className={window.innerWidth > 768 ? "bi bi-whatsapp" : "bi bi-telephone-fill"}></i>
                  <div>
                    <h5 className='text-start'>{window.innerWidth > 768 ? "Whatsapp " : "Call"}</h5>
                    <a href={window.innerWidth > 768 ? "https://wa.me/+917358052100" : "tel:+917358052100"} target='blank' >+91 7358052100</a>
                  </div>
                </div>
                <div className="contact-info-item">
                  <i className="bi bi-envelope-fill"></i>
                  <div>
                    <h5 className='text-start'>Email Us</h5>
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to=admin@breathcomfort.in"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      admin@breathcomfort.in
                    </a>
                  </div>

                </div>
                <div className="text-center mt-4">
                  <a href="#formsubmission" className="btn scroll-down-btn">
                    <i className="bi bi-arrow-down-circle" ></i> Scroll to Form
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <a href="#formsubmission">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="arrow">
            <span></span>
          </div>
        </a>
      </div>
    </section>
  );
}

export default ContactHeroSection;